import React from 'react'

function About() {
  return (
    <section className='section-container'>
      <h2>Hello!</h2>
      <p>
        My name is Nikolaz, a web developer from France.
        I started developing as a hobby in 2019 and since then I have put quite a few
        web app online.
        <br/>
        The tools I use are React and Ruby on Rails. I started web development with React,
        however it has been really useful to create some APIs of my own with Rails.
        Here you can check out
        <a href='https://nikolaz.tech/' target='_blank' rel="noreferrer" className='blue-text'> my portolio </a>
        and
        <a href='https://github.com/nikolaz90' target='_blank' rel="noreferrer" className='blue-text'> my github</a>
      </p>
    </section>
  )
}

export default About
